export const pad = (num, size = 2) => {
  let s = num + ''
  while (s.length < size) {
    s = '0' + s
  }
  return s
}

// add [] to arrays to work with PHP for router
export const addArraySyntax = (params: Object) => {
  // make a copy of our object that we can mutate
  const paramsWithArray = JSON.parse(JSON.stringify(params))
  Object.entries(paramsWithArray).forEach(([key, val]) => {
    if (Array.isArray(val)) {
      paramsWithArray[key + '[]'] = val
      delete paramsWithArray[key]
    }
  })

  return paramsWithArray
}

// remove [] from keys in params {} like this.$route.query
export const removeArraySyntax = (params: Object) => {
  // make a copy of our object that we can mutate
  const paramsRemoveArray = JSON.parse(JSON.stringify(params))

  Object.keys(params)
    .filter((key) => key.endsWith('[]'))
    .forEach((key) => {
      const newKey = key.replace('[]', '')

      // this.$route.query is [] if multiple values but not if just 1
      paramsRemoveArray[newKey] = Array.isArray(params[key]) ? params[key] : [params[key]]
      delete paramsRemoveArray[key]
    })

  return paramsRemoveArray
}

/**
 * Convert a JS object to query string params.  Currently not recursive.
 * and expects objects to flat.
 */
export const objToQueryString = (obj: Object): string => {
  if (typeof URLSearchParams !== 'undefined') {
    return new URLSearchParams(obj).toString()
  }

  // ie11 and safari 9 fallback
  return Object.keys(obj)
    .reduce((acc, key) => {
      acc.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
      return acc
    }, [])
    .join('&')
}

/**
 * Used when comparing strings that are actually floats.
 * @see https://stackoverflow.com/questions/21690070/javascript-float-comparison/55164784#55164784
 */
export const compareFloats = (amount1: string, operator: string, amount2: string): boolean => {
  const realAmount1 = Math.round(Number.parseFloat(amount1) * 100000)
  const realAmount2 = Math.round(Number.parseFloat(amount2) * 100000)

  if (operator === '>') {
    return realAmount1 > realAmount2
  }

  if (operator === '>=') {
    return realAmount1 >= realAmount2
  }

  if (operator === '<') {
    return realAmount1 < realAmount2
  }

  if (operator === '<=') {
    return realAmount1 <= realAmount2
  }

  return false
}

export const moneyFormat = (val: string): string => {
  return Number.parseFloat(val).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}

export const numberFormat = (val: string): string => {
  return Number.parseFloat(val).toLocaleString('en-US')
}
